<script>
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";

// Custom Componetns
import PageHeader from "@/components/page-header";
import hkService from "@/helpers/APIService/hk.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// DND Component

export default {
  page: {
    title: "DND List",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
  },
  data() {
    return {
      title: "DND List List",

      isLoading: true,
      table: {
        tableData: [],
      },
      name: "",
      is_active: false,
      reasonTitle: "Add New DND Reason",
      reasonId: "",
      isEdit: false,
      submitted: false,
      selectedRoomType: null,
      is_btn_loading: false,
      createError: false,
      errorMessage: null,
      isUniqueValue: false,
      uniqueValueMessage: {
        name: "",
      },
      dndNameList: [],
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getDNDReasonList();
  },
  methods: {
    async getDNDReasonList() {
      await hkService
        .getDNDReasonList()
        .then((response) => {
          response.map((item) => {
            this.dndNameList.push(item.name.toLowerCase());
          });
          this.table.tableData = response;
          this.isLoading = false;
        })
        .catch((error) => {
          this.createError = true;
          errorHandler(error);
          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
    },
    changeDNDStatus(id, data) {
      hkService
        .updateDNDReason(id, data)
        .then(() => {
          Middleware.notification("Status successfully changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    editData(data) {
      this.isEdit = true;
      this.reasonTitle = "Update DND Reason";
      this.name = data.name;
      this.is_active = data.is_active;
      this.reasonId = data.id;
      this.$refs["dnd-reason-modal"].show();
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      this.isUniqueValue = false;
      this.submitted = true;
      this.is_btn_loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.is_btn_loading = false;
        return;
      } else {
        if (this.isEdit) {
          this.dndNameList = this.dndNameList.filter(
            (item) => item !== this.name.toLowerCase()
          );
        }
        if (this.dndNameList.includes(this.name.toLowerCase().trim())) {
          this.isUniqueValue = true;
          this.is_btn_loading = false;
          this.uniqueValueMessage.name = "name must be unique";
        } else {
          this.uniqueValueMessage.name = "";
        }
        if (!this.isUniqueValue) {
          if (this.isEdit) {
            hkService
              .updateDNDReason(this.reasonId, {
                hotel: this.hotel.id,
                name: this.name,
                is_active: this.is_active,
              })
              .then((response) => {
                Middleware.notification("Successfully updated !!", "success");

                this.is_btn_loading = false;
                this.table.tableData = this.table.tableData.map((item) => {
                  if (item.id === response.id) {
                    item = response;
                  }
                  return item;
                });
                this.resetModal();
              })
              .catch((error) => {
                this.createError = true;
                this.is_btn_loading = false;
                errorHandler(error);
                if (typeof error.response.data.non_field_errors == "object") {
                  this.errorMessage = error.response.data.non_field_errors;
                } else {
                  this.errorMessage = error.response.data;
                }
              });
          } else {
            hkService
              .createDNDReason({
                hotel: this.hotel.id,
                name: this.name,
                is_active: this.is_active,
              })
              .then((response) => {
                Middleware.notification("Successfully created !!", "success");

                this.is_btn_loading = false;
                this.table.tableData.push(response);
                this.resetModal();
              })
              .catch((error) => {
                this.createError = true;
                this.is_btn_loading = false;
                errorHandler(error);
                if (typeof error.response.data.non_field_errors == "object") {
                  this.errorMessage = error.response.data.non_field_errors;
                } else {
                  this.errorMessage = error.response.data;
                }
              });
          }
        }
      }
    },

    deleteData(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          hkService
            .deleteDNDReason(id)
            .then(() => {
              let index = this.table.tableData.findIndex((el) => el.id === id);
              this.table.tableData.splice(index, 1);
              Middleware.notification("Successfully deleted !!", "danger");
              this.isLoading = false;
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    resetModal() {
      this.$refs["dnd-reason-modal"].hide();
      this.isEdit = false;
      this.reasonId = "";
      this.reasonTitle = "Add New DND Reason";
      this.name = "";
      this.is_active = false;
      this.createError = false;
      this.errorMessage = null;
      this.isUniqueValue = false;
      this.uniqueValueMessage = {
        name: "",
      };
    },
  },
  validations: {
    name: { required },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      v-b-modal.dnd-reason-modal
      text="Add New"
      :isButton="true"
    />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 mt-2">
                <div class="table-responsive mb-0">
                  <!-- Table -->
                  <table
                    class="table table-hover mb-0"
                    ref="my-table"
                    v-infinite-scroll="getDNDReasonList"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                  >
                    <thead class="table-light">
                      <tr>
                        <th>Name</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-if="isLoading">
                      <tr v-for="(item, index) in 5" :key="index">
                        <td class="placeholder-glow" v-for="no in 3" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr v-for="(data, index) in table.tableData" :key="index">
                        <td @click="editData(data)">
                          {{ data.name }}
                        </td>
                        <td>
                          <div class="form-check form-switch my-1">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              v-model="data.is_active"
                              @change="
                                changeDNDStatus(data.id, {
                                  is_active: data.is_active,
                                })
                              "
                            />
                          </div>
                        </td>
                        <td>
                          <div slot="actions" class="d-flex align-items-center">
                            <i
                              class="fas fa-pencil-alt me-2 text-success"
                              title="Edit Record"
                              @click="editData(data)"
                            ></i>
                            <i
                              class="mdi mdi-trash-can fs-5 text-danger"
                              title="Delete Record"
                              @click="deleteData(data.id)"
                            >
                            </i>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="!isLoading && table.tableData.length == 0">
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="dnd-reason-modal"
      centered
      :title="reasonTitle"
      hide-footer
      title-class="font-18"
      @hidden="resetModal"
      ref="dnd-reason-modal"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-6">
            <b-form-group class="mb-3" label="Name" label-for="name">
              <span slot="label">Name <span class="text-danger">*</span> </span>
              <b-form-input
                id="title-input"
                type="text"
                v-model="name"
                autocomplete="off"
                :class="{
                  'is-invalid':
                    (submitted && $v.name.$error) ||
                    (isUniqueValue && uniqueValueMessage.name !== ''),
                }"
              ></b-form-input>
              <div v-if="submitted && $v.name.$error" class="invalid-feedback">
                <span v-if="!$v.name.required"
                  >DND Reason name is required.</span
                >
              </div>
              <div v-if="isUniqueValue" class="invalid-feedback">
                <span v-if="uniqueValueMessage.name !== ''">{{
                  uniqueValueMessage.name
                }}</span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group class="mb-3" label="is_active" label-for="is_active">
              <div class="form-check form-switch mb-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  style="width: 2rem; height: 1rem"
                  v-model="is_active"
                  autocomplete="off"
                />
              </div>
            </b-form-group>
          </div>
          <h4 v-if="createError">
            <template v-if="typeof errorMessage == 'object'">
              <span v-for="error in errorMessage" :key="error">
                <span class="badge card-badge badge-soft-danger">
                  <b>{{ error }}</b>
                </span>
                <br />
              </span>
            </template>
            <template v-else>
              <span class="badge card-badge badge-soft-danger">
                <b>{{ errorMessage }}</b>
              </span>
            </template>
          </h4>
          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="resetModal"
              >Cancel
            </b-button>
            <b-button
              class="float-end"
              variant="outline-primary"
              type="button"
              @click="handleOk"
              :class="{ disabled: is_btn_loading }"
            >
              <i
                v-if="is_btn_loading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i>
              {{ isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
